<template>
    <div>
      <br />
    <b-card>
       <b-row><b-col>User: {{this.fullname}}</b-col><b-col>Date: {{ this.today  }}</b-col></b-row>
       <br/>
       <b-row><b-col>Is Note Device Specific:</b-col><b-col><b-form-select v-model="DeviceSpecific" :options="options"></b-form-select></b-col></b-row>
       <br/>
       <b-row v-if="this.DeviceSpecific == 'true'"><b-col>Associated Device:</b-col><b-col><b-form-select v-model="SelectedDevice">
          <option
            v-for="Device in this.DeviceList"
            v-bind:value="Device"
            v-bind:key="Device.DeviceName"
            >{{ Device.DeviceName }} - {{ Device.DeptArea }}</option
          >
        </b-form-select></b-col> </b-row>
        <br/>
       <b-row><b-col>Note Title:</b-col><b-col>      <b-form-input
        v-model="NoteTitle"
        placeholder="Title of Note"
      ></b-form-input></b-col></b-row>
      <br/>
       <b-row><b-col>Note Trigger:</b-col><b-col>Manual Entry</b-col></b-row>
       <br/>
       <b-row><b-col>Note Text:</b-col><b-col><b-form-textarea
      id="NoteTextArea"
      v-model="NoteText"
      placeholder="Please provide details for Logbook here"
      rows="3"
      max-rows="3"
    ></b-form-textarea></b-col></b-row>
    <br/>
       <b-row><b-col align="right"><b-button variant="outline-success" v-on:click="SubmitEntry()">Submit</b-button></b-col><b-col align="left"><b-button variant="outline-danger" v-on:click="CancelEntry()">Cancel</b-button></b-col></b-row>
    </b-card>
    </div>
  </template>
  
  <script>
    import axios from "axios";
  
  export default {
    data() {
      return {
        selectedlocation: localStorage.getItem("location"),
        UserAccess: localStorage.getItem("accessGroup"),
        UserURN: localStorage.getItem("UserURN"),
        UserProfile: localStorage.getItem("profileportal"),
        fullname: localStorage.getItem("fullname"),
        CreatorFirstName: "",
        CreatorLastName: "",
        today: "",
        LogEntry: {
            DeviceID: "",
            Location: "",
            NoteDate: "",
            NoteTime: "",
            NoteTrigger: "",
            NoteTitle: "",
            NoteText: "",
            UserName: ""
        },
        NoteTitle: "",
        NoteText: "",
        SelectedDevice: null,
        DeviceList: [],
        DeviceSpecific: null,
        options: [{ value: null, text: 'Please select an option' },
           { value: 'true', text: 'Yes' },
           { value: 'false', text: 'No' }],
      };
    },
    mounted() {
        let current = new Date();
        this.today = current.getFullYear()+'-'+(current.getMonth()+1)+'-'+current.getDate();

        let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "DevicesWithNames",
      Location: this.selectedlocation,
    };

    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        let DeviceData = response.data.Values;
        for (let i = 0; i < DeviceData.length; i++) {
          let TempDeviceType = DeviceData[i][4];
          let TempDeviceName = DeviceData[i][1];
          let TempDeptArea = DeviceData[i][3];
          let TempDeviceID = DeviceData[i][0];
          let TempDeviceLocation = DeviceData[i][2];

          this.DeviceList.push({
            DeviceType: TempDeviceType,
            DeviceName: TempDeviceName,
            DeptArea: TempDeptArea,
            DeviceID: TempDeviceID,
            DeviceLocation: TempDeviceLocation,
          });
        }
      });
      
    },
  
    components: {},
    methods: {
        SubmitEntry(){

          if(this.DeviceSpecific == "" || this.NoteTitle == "" || this.NoteText == ""){
            alert("All fields on this page must be completed prior to submitting")
          }
          if(this.DeviceSpecific == "true" && this.SelectedDevice == null){
            alert("Please select a device from the drop down menu")
          }
          else {

            let deviceforsend = ""
            if(this.DeviceSpecific == 'false'){
              deviceforsend = 'N/A'
            } else{
              deviceforsend = this.SelectedDevice.DeviceID
            }


            let SubmitUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/notes";
        let SubmitHeaders = this.$apikeyPost;
        let SubmitLookUpRequest = {
          RequestType: "CreateVirtualLog",
          RequestVariable: "",
          DataDict: [
            {
              DeviceID:deviceforsend,
              Location: this.selectedlocation ,
              NoteDate: this.today ,
              NoteTime: new Date().toLocaleTimeString(),
              NoteTrigger: 'Manual Entry' ,
              NoteTitle: this.NoteTitle,
              NoteText: this.NoteText,
              UserName: this.fullname
            },],
        };
        axios
          .post(SubmitUrl, SubmitLookUpRequest, SubmitHeaders)
          .then((response) => {
            response;
            alert("Note Submitted");
            this.NoteTitle = "",
            this.NoteText = "",
            this.SelectedDevice = null,
            this.DeviceSpecific - null,
            this.LogEntry =  {
            DeviceID: "",
            Location: "",
            NoteDate: "",
            NoteTime: "",
            NoteTrigger: "",
            NoteTitle: "",
            NoteText: "",
            UserName: ""
            }
        });
      }
        },
        CancelEntry(){
            this.NoteTitle = "",
            this.NoteText = "",
            this.SelectedDevice = null,
            this.DeviceSpecific = null
            this.LogEntry =  {
            DeviceID: "",
            Location: "",
            NoteDate: "",
            NoteTime: "",
            NoteTrigger: "",
            NoteTitle: "",
            NoteText: "",
            UserName: ""
        }
        }

    },
    watch: {
    },
 
  };
  </script>
  <style scoped>

</style>
  